import React from 'react';
import moment from 'moment-timezone';

import {
    casoRevision,
    importeConComa,
    nombreCompletoPersona,
} from '../../../helpers/cobroDatafono';

const FORMATO_FECHA_HORA = 'DD/MM/YYYY HH:mm';

const fechaHora = (fecha) => (fecha ? moment(fecha).format(FORMATO_FECHA_HORA) : '');

/**
 * Un cobro con la tarjeta cobrada y sin venta registrada.
 *
 * Lo que domina la fila es qué pasó y qué se espera del negocio: los tres casos piden acciones
 * distintas y el operario tiene que poder distinguirlos sin interpretarlos.
 *
 * EX-613: las dos salidas se ofrecen siempre y con el mismo peso. La pantalla no elige por el
 * operario —quien revisa es quien sabe qué pasó en el terminal—, así que se distinguen por la
 * etiqueta y el color, nunca presentando una como la acción recomendada.
 */
export const CobroRevisionFila = ({ cobro, onResolver, onGenerarVenta, accionEnCurso }) => {
    const caso = casoRevision(cobro.estado);
    const cliente = nombreCompletoPersona(cobro.cliente);
    const revisor = nombreCompletoPersona(cobro.resueltoPor);
    // El teléfono es la vía para avisar al cliente de una devolución, que es justo el desenlace
    // más habitual de un cobro tras cancelación.
    const telefonoCliente = cobro.cliente?.telefono;

    return (
        <div className={`cobro-fila ${cobro.resuelto ? 'cobro-fila--resuelta' : ''}`}>
            <div className="cobro-fila__cabecera">
                <span className="cobro-fila__importe">{importeConComa(cobro.importe)}</span>
                <span className="cobro-fila__fecha">{fechaHora(cobro.creacion)}</span>
            </div>

            <div className={`cobro-fila__caso cobro-fila__caso--${caso.tono}`}>
                <p className="cobro-fila__que-paso">{caso.queHaPasado}</p>
                <p className="cobro-fila__que-hacer">{caso.queHacer}</p>
                {cobro.detalleError && (
                    <p className="cobro-fila__detalle">Detalle: {cobro.detalleError}</p>
                )}
            </div>

            <div className="cobro-fila__datos">
                <span>
                    <strong>Cliente:</strong> {cliente || 'No identificado'}
                    {telefonoCliente && ` · ${telefonoCliente}`}
                </span>
                <span>
                    <strong>Cita:</strong>{' '}
                    {cobro.cita
                        ? (fechaHora(cobro.cita.fecha) || 'sin fecha disponible')
                        : 'sin cita asociada'}
                </span>
                <span><strong>Local:</strong> {cobro.sucursal?.nombre || 'sin local'}</span>
                <span><strong>Terminal:</strong> {cobro.terminal?.nombre || 'sin identificar'}</span>
            </div>

            {cobro.resuelto ? (
                <div className="cobro-fila__constancia">
                    <span>
                        Revisado por {revisor || 'un usuario ya eliminado'} el{' '}
                        {fechaHora(cobro.resueltoEn)}
                    </span>
                    {cobro.notaResolucion && <span>Nota: {cobro.notaResolucion}</span>}
                </div>
            ) : (
                <div className="cobro-fila__acciones">
                    <button
                        type="button"
                        className="btn-resolver"
                        disabled={accionEnCurso}
                        onClick={() => onResolver(cobro)}
                    >
                        Marcar como resuelto
                    </button>
                    <button
                        type="button"
                        className="btn-resolver btn-resolver--venta"
                        disabled={accionEnCurso}
                        onClick={() => onGenerarVenta(cobro)}
                    >
                        Generar la venta
                    </button>
                </div>
            )}
        </div>
    );
};
